import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const practiceAreaApi = createApi({
  reducerPath: "practiceArea",
  tagTypes: ["PracticeAreas"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getPracticeAreas: builder.query({
      query: () => "api/v2/practice_areas",
      transformResponse: (response: any) => {
        return response.practice_areas;
      }
    })
  })
});

export const { useGetPracticeAreasQuery } = practiceAreaApi;
